"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactorumRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var Units_1 = require("../../../Units");
var FactorumRebalanced = (function (_super) {
    __extends(FactorumRebalanced, _super);
    function FactorumRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.FACTORUM_REBALANCED,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            startingMegaCredits: 40,
            productionBox: Units_1.Units.of({ steel: 2 }),
            metadata: {
                cardNumber: 'R22',
                description: 'You start with 40 M€. Increase your steel production 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(40).nbsp.production(function (pb) { return pb.steel(2); });
                    b.corpBox('action', function (ce) {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Increase your energy production 1 step IF YOU HAVE NO ENERGY RESOURCES, or spend 1 energy to draw a building card.', function (eb) {
                            eb.empty().arrow().production(function (pb) { return pb.energy(1); });
                            eb.or().energy(1).startAction.cards(1).secondaryTag(Tags_1.Tags.BUILDING);
                        });
                    });
                }),
            },
        }) || this;
    }
    FactorumRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.STEEL, 2);
        return undefined;
    };
    FactorumRebalanced.prototype.canAct = function () {
        return true;
    };
    FactorumRebalanced.prototype.action = function (player) {
        if (player.energy > 0) {
            player.deductResource(Resources_1.Resources.ENERGY, 1);
            player.drawCard(1, { tag: Tags_1.Tags.BUILDING });
        }
        else {
            player.addProduction(Resources_1.Resources.ENERGY, 1, { log: true });
        }
        return undefined;
    };
    return FactorumRebalanced;
}(Card_1.Card));
exports.FactorumRebalanced = FactorumRebalanced;
//# sourceMappingURL=FactorumRebalanced.js.map